// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"408":"640de5b2396df39d","3224":"833186f7e47798ad","5352":"4caddd4dd6410d72"}[chunkId] + ".css";
};